<template>
  <div class="top">
    <div style="width: 1160px;margin: auto;display: flex;justify-content: space-between;">
      <div class="top-img" @click="goShow">
        <img src="@/assets/newImg5/logo2.png" class="img-sty" alt="" />
      </div>
      <div>
        <div style="line-height: 78px; color: red; cursor: pointer" @click="logOut">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    logOut() {
      // const { href } = this.$router.resolve({
      //   path: "/"
      // });
      // window.open(href, "_blank");
      console.log('走着了');
      this.$bus.$emit('exit')
      this.$bus.$emit("loginCancel", (data) => {

      });
      this.$router.push({
        path: '/'
      })
      this.userShow = false;
      window.localStorage.removeItem("user_id");
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("userName");
      window.localStorage.removeItem("headPic");
      this.$message({
        type: "success",
        message: "账号已退出"
      });
    },
    goShow() {
      const { href } = this.$router.resolve({
        path: "/"
      });
      window.open(href, "_blank");
    }
  },
  created() { },
  mounted() { }
};
</script>

<style lang="scss" scoped>
.top {
  position: fixed !important;
  top: 0px !important;
  z-index: 1500;
}

// @media screen and (min-width: 100px) and (max-width: 1500px) {
//   .top {
//     height: 70px;
//     width: 100vw;
//     display: flex;
//     box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);

//     opacity: 1;
//     display: flex;
//     background: #ffffff;
//     backdrop-filter: blur(20px);
//     position: relative;

//     .top-img {
//       margin: 0;
//       padding: 0;
//       width: 13vw !important;
//       // width: 190px;
//       cursor: pointer;
//       height: 67px !important;

//       .img-sty {
//         width: 145px;
//         height: 48px;
//         margin-top: 5%;
//         margin-left: 20px;
//         // padding: 0px 24px;
//       }
//     }
//   }
// }

// @media screen and (min-width: 1500px) and (max-width: 1900px) {
//   .top {
//     position: relative;

//     height: 70px;
//     width: 100vw;
//     display: flex;
//     box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);

//     opacity: 1;
//     display: flex;
//     background: #ffffff;
//     backdrop-filter: blur(20px);

//     .top-img {
//       margin: 0;
//       padding: 0;
//       width: 13vw !important;
//       // width: 190px;
//       cursor: pointer;
//       height: 67px !important;

//       .img-sty {
//         width: 152px;
//         height: 48px;
//         margin-top: 5%;
//         padding: 0px 30px;
//         // padding: 0px 32px;
//       }
//     }
//   }
// }

.top {
  position: relative;
  height: 70px;
  width: 100vw;
  display: flex;
  // float: ;
  // position: fixed;
  opacity: 1;
  display: flex;
  background: #ffffff;
  backdrop-filter: blur(20px);
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);

  padding-bottom: 5px;

  .top-img {
    margin: 0;
    padding: 0;
    width: 13vw !important;
    // width: 190px;
    cursor: pointer;
    height: 67px !important;

    .img-sty {
      // width: 160px;
      // height: 50px;
      // margin-top: 5%;
      width: 100px;
      height: 82px;
      padding: 0px 0px;
    }
  }
}



// .top {
//   position: relative;
//   box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);

//   height: 70px;
//   width: 100vw;
//   display: flex;
//   // float: ;
//   // position: fixed;
//   opacity: 1;
//   display: flex;
//   background: #ffffff;
//   backdrop-filter: blur(20px);

//   .top-img {
//     margin: 0;
//     padding: 0;
//     width: 13vw !important;
//     // width: 190px;
//     cursor: pointer;
//     height: 67px !important;

//     .img-sty {
//       width: 160px;
//       height: 48px;
//       margin-top: 3%;
//       padding: 0px 32px;
//     }
//   }
// }</style>
